<app-energy-interface-list-section>
  <div slot="title" class="flex items-center gap-2.5 overflow-hidden">
    <div
      class="flex-none block h-5 w-1 rounded-full"
      [style.background-color]="
        location().data?.name + (location().data?.address | address) | randomColor
      "
    ></div>
    <span class="overflow-hidden text-ellipsis whitespace-nowrap">
      <a
        class="font-semibold hover:underline cursor-pointer"
        [routerLink]="[
          '/organizations',
          organizationId(),
          'locations',
          location().id,
          'energy-interfaces',
        ]"
        >{{ location().data?.name || (location().data | formatLocationName) }}</a
      >
      @if (location().data?.name) {
        <span>, {{ location().data?.address | address }}</span>
      }
    </span>
  </div>
  <ui-button slot="header" mode="ghost" class="flex-none" (click)="clickCreate.emit(location().id)">
    {{ 'cockpit.energyInterfaces.list.addButton' | transloco }}
  </ui-button>

  @if (energyInterfaces().length > 0) {
    <app-energy-interface-list>
      @for (energyInterface of energyInterfaces(); track energyInterface.id) {
        <app-energy-interface-list-entry
          [energyInterface]="energyInterface"
          [organizationId]="organizationId()"
        />
      }
    </app-energy-interface-list>
  } @else {
    <app-energy-interface-list-empty
      (clickCreate)="clickCreate.emit(location().id)"
      class="block w-full"
    />
  }
</app-energy-interface-list-section>
